import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    paddingBottom: 0,
    flexDirection: 'column'
  },

  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: ' 1fr',
      gap: theme.spacing(0)
    },
    gap: theme.spacing(2)
  },
  cell: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  chip: { fontSize: 12 },
  cellText: { marginLeft: '6px', fontSize: 13, fontWeight: 500 },
  radioIcon: {
    '& svg': {
      fontSize: 18
    }
  },
  label: { color: theme.palette.text.primary, fontSize: 14 },
  input: {
    height: 38
  },
  divider: { margin: '8px 0' }
}))
